import ImageHeader from './ImageHeader';

export { default as ImageHeader } from './ImageHeader';
export type { ImageHeaderProps } from './ImageHeader.types';

export default ImageHeader;
